import { useAuth0 } from "@auth0/auth0-react";
import { useMemo } from "react";

import {
  extractRoles,
  hasPermission,
  isLegalUser,
  isTravelCustomer,
  isUpclaimDirectionUser,
  isUpclaimUser,
  type PermissionRequirement,
} from "@/lib/permissions";

export function useCurrentUser() {
  const { user } = useAuth0();

  return useMemo(() => {
    const roles = extractRoles(user);
    return {
      user,
      roles,
      can: (required: PermissionRequirement) => hasPermission(roles, required),
      isUpclaim: isUpclaimUser(roles),
      isUpclaimDirection: isUpclaimDirectionUser(roles),
      isLegalUser: isLegalUser(roles),
      isTravelCustomer: isTravelCustomer(roles),
    };
  }, [user]);
}
